"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.operations = void 0;
var evm_1 = require("./evm");
var solana_1 = require("./solana");
var aptos_1 = require("./aptos");
exports.operations = [
    solana_1.requestChallengeSolanaOperation,
    evm_1.requestChallengeEvmOperation,
    aptos_1.requestChallengeAptosOperation,
    solana_1.verifyChallengeSolanaOperation,
    evm_1.verifyChallengeEvmOperation,
    aptos_1.verifyChallengeAptosOperation,
    evm_1.getAddressesOperation,
    evm_1.removeBindOperation,
    evm_1.requestBindOperation,
    evm_1.verifyRemoveBindOperation,
    evm_1.verifyRequestBindOperation,
];
//# sourceMappingURL=operations.js.map